export default "__VITE_ASSET__SX4L_0F8__"